import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import TableMain from "../../components/Common/table/TableMain";
import { useNavigate } from "react-router";
import HeaderButton from "../../components/Common/buttons/HeaderButtton";
import MeetingModal from "./MeetingModal";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const MyMeetings = () => {
    const headers =
        [
            "title",
            "description",
            "Date",
            "startTime",
            "endTime",
            "link",
            "action"
        ];

    const { t } = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient()
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [show, setShow] = useState(false);

    const pendingUsers = ApiHook.CallMyMeetings(
        currentPage,
        itemsPerPage,
    );

    const updateMeeting = ApiHook.CallUpdateMeeting();

    const handleShow = () => {
        setShow(!show)
    }

    const handleClose =()=>{
        queryClient.refetchQueries({queryKey:["get-user-meetings"]})
        setShow(false)
    }

    const updateMeetingStatus = async (data) => {
        const response = await updateMeeting.mutateAsync(data)
        if (response.status) {
            toast.success(data?.status == 0 ? "Deleted" : "Updated")
            queryClient.refetchQueries({queryKey:["get-user-meetings"]})
        } else {
            toast.error("Failed")
        }
    }

    return (
        <>
            <div className="page_head_top">{t("Meeting Configurations")}</div>
            <HeaderButton
                title={show?"Close":"Add New"}
                handleClick={handleShow}
            />
            <div className="ewallet_top_btn_sec">
                <div className="row justify-content-between">


                    {show ?
                        <MeetingModal handleClose={handleClose} />
                        : <div className="ewallet_table_section">
                            <div className="ewallet_table_section_cnt">
                                <div className="ewallet_table_section_cnt_tab_head">
                                </div>
                            </div>
                            <div className="table-responsive min-hieght-table">
                                <>

                                    <TableMain
                                        headers={headers}
                                        data={pendingUsers?.data?.data}
                                        startPage={1}
                                        currentPage={currentPage}
                                        totalPages={pendingUsers?.data?.totalPages}
                                        setCurrentPage={setCurrentPage}
                                        type={"my_meetings"}
                                        itemsPerPage={itemsPerPage}
                                        setItemsPerPage={setItemsPerPage}
                                        updateMeetingStatus={updateMeetingStatus}
                                    />
                                </>

                            </div>
                        </div>}
                </div>
            </div>
        </>

    );
};

export default MyMeetings;